import React from 'react'

const Scenes = ({ children }) => {
  return <div>{children}</div>
}

export default Scenes
